(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_c675140"] && !Shopify.designMode) return;
  try {
    class TracingWorksheetGenerator extends HTMLElement {
    connectedCallback() {
      this.blockId = this.dataset.blockId;
      this.rowsPerPage = parseInt(this.dataset.rowsPerPage, 10) || 8;
      this.fontUrl = this.dataset.fontUrl || '';
      this.isGenerating = false;
      this.lastObservedWidth = 0;
      this.textInput = this.querySelector('#tracing-text-' + this.blockId);
      this.colorInput = this.querySelector('#tracing-color-' + this.blockId);
      this.colorValue = this.querySelector('.ai-tracing-generator__color-value-' + this.blockId);
      this.generateButton = this.querySelector('[data-generate-button]');
      this.printButton = this.querySelector('[data-print-button]');
      this.previewContainer = this.querySelector('[data-preview-container]');
      this.previewContent = this.querySelector('[data-preview-content]');
      if (!this.textInput || !this.generateButton || !this.previewContent) {
        return;
      }
      this.setupEventListeners();
      this.setupResizeObserver();
    }
    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      clearTimeout(this.resizeTimeout);
    }
    setupResizeObserver() {
      if (this.resizeObserver) {
        return;
      }
      this.lastObservedWidth = Math.round(this.getBoundingClientRect().width);
      this.resizeObserver = new ResizeObserver(() => {
        if (this.isGenerating) {
          return;
        }
        const width = Math.round(this.getBoundingClientRect().width);
        // Only regenerate when width changes — height changes from rebuilding
        // the preview were causing a blink/re-render loop
        if (Math.abs(width - this.lastObservedWidth) < 2) {
          return;
        }
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          if (this.isGenerating) {
            return;
          }
          if (
            !this.previewContainer.classList.contains('active') ||
            !this.textInput.value.trim()
          ) {
            this.lastObservedWidth = Math.round(this.getBoundingClientRect().width);
            return;
          }
          const nextWidth = Math.round(this.getBoundingClientRect().width);
          if (Math.abs(nextWidth - this.lastObservedWidth) < 2) {
            return;
          }
          this.lastObservedWidth = nextWidth;
          this.generateWorksheet({ scrollIntoView: false });
        }, 300);
      });
      this.resizeObserver.observe(this);
      if (this.previewContent) {
        this.resizeObserver.observe(this.previewContent);
      }
    }
    getTracingFontSize() {
      const probe = document.createElement('span');
      probe.className = 'ai-tracing-generator__tracing-text-' + this.blockId;
      probe.style.visibility = 'hidden';
      probe.style.position = 'absolute';
      probe.style.pointerEvents = 'none';
      probe.textContent = 'Ag';
      this.appendChild(probe);
      const fontSize = parseFloat(window.getComputedStyle(probe).fontSize) || 40;
      probe.remove();
      return fontSize;
    }
    async ensureFontReady() {
      if (!document.fonts) {
        return;
      }
      const fontSize = this.getTracingFontSize();
      try {
        await document.fonts.load(fontSize + 'px "EagerSentenceTracing"');
        await document.fonts.ready;
      } catch (error) {
        // Continue with fallback metrics if font load fails
      }
    }
    waitForLayout() {
      return new Promise(function (resolve) {
        requestAnimationFrame(function () {
          requestAnimationFrame(resolve);
        });
      });
    }
    getFitSafety(el) {
      const fontSize = parseFloat(window.getComputedStyle(el).fontSize) || 40;
      const isNarrow = window.matchMedia('(max-width: 749px)').matches;
      return isNarrow
        ? Math.max(6, fontSize * 0.22)
        : Math.max(12, fontSize * 0.45);
    }
    getPreviewTextWidth(el) {
      const width = el.clientWidth;
      if (!window.matchMedia('(max-width: 749px)').matches) return width;
      const style = window.getComputedStyle(el);
      const left = parseFloat(style.paddingLeft) || 0;
      const right = parseFloat(style.paddingRight) || 0;
      // clientWidth includes padding; keep the tracing letters inside it.
      return Math.max(0, width - left - right);
    }
    textFitsInSlot(el, text) {
      el.textContent = '';
      const inner = document.createElement('span');
      inner.className = 'ai-tracing-generator__tracing-text-inner-' + this.blockId;
      inner.textContent = text;
      el.appendChild(inner);
      const available = this.getPreviewTextWidth(el);
      const used = inner.getBoundingClientRect().width;
      const safety = this.getFitSafety(el);
      return used <= available - safety;
    }
    fitRowsWithinWidth() {
      const rows = Array.from(
        this.previewContent.querySelectorAll(
          '.ai-tracing-generator__worksheet-row-' + this.blockId
        )
      );
      if (!rows.length) return;
      const measurements = [];
      let targetWidth = Infinity;
      rows.forEach((row) => {
        const textEl = row.querySelector(
          '.ai-tracing-generator__tracing-text-' + this.blockId
        );
        const inner = row.querySelector(
          '.ai-tracing-generator__tracing-text-inner-' + this.blockId
        );
        if (!textEl || !inner || !inner.textContent) return;
        inner.style.transform = 'none';
        inner.style.transformOrigin = 'left center';
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const available = Math.max(0, this.getPreviewTextWidth(textEl) - (isMobile ? this.getFitSafety(textEl) : 0));
        const used = inner.getBoundingClientRect().width;
        measurements.push({ inner, used });
        if (available > 1) {
          targetWidth = Math.min(targetWidth, available);
        }
      });
      if (!Number.isFinite(targetWidth) || targetWidth < 1) return;
      measurements.forEach((item) => {
        if (item.used > 1) {
          item.inner.style.transform = 'scaleX(' + targetWidth / item.used + ')';
        }
      });
    }
    /**
     * Wrap words across lines until the full input is written,
     * then restart from the beginning and repeat to fill remaining rows.
     */
    buildWrappedRepeatingRows(el, sentence, rowCount) {
      const words = sentence.split(/\s+/).filter(Boolean);
      const rows = [];
      if (!words.length) {
        for (let i = 0; i < rowCount; i++) {
          rows.push('');
        }
        el.textContent = '';
        return rows;
      }
      let wordIndex = 0;
      for (let r = 0; r < rowCount; r++) {
        let lineText = '';
        let guard = 0;
        while (guard++ < 1000) {
          const word = words[wordIndex % words.length];
          const candidate = lineText ? lineText + ' ' + word : word;
          if (!this.textFitsInSlot(el, candidate)) {
            if (!lineText) {
              lineText = word;
              wordIndex += 1;
            }
            break;
          }
          lineText = candidate;
          wordIndex += 1;
        }
        rows.push(lineText);
      }
      el.textContent = '';
      return rows;
    }
    createWorksheetRow(lineText, color) {
      const row = document.createElement('div');
      row.className = 'ai-tracing-generator__worksheet-row-' + this.blockId;
      const tracingText = document.createElement('div');
      tracingText.className = 'ai-tracing-generator__tracing-text-' + this.blockId;
      tracingText.style.color = color;
      const inner = document.createElement('span');
      inner.className = 'ai-tracing-generator__tracing-text-inner-' + this.blockId;
      inner.textContent = lineText;
      tracingText.appendChild(inner);
      row.appendChild(tracingText);
      return row;
    }
    setupEventListeners() {
      this.colorInput.addEventListener('input', () => {
        this.colorValue.textContent = this.colorInput.value;
      });
      this.generateButton.addEventListener('click', () => {
        this.generateWorksheet({ scrollIntoView: true });
      });
      this.printButton.addEventListener('click', () => {
        this.printWorksheet();
      });
      this.textInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.ctrlKey) {
          e.preventDefault();
          this.generateWorksheet({ scrollIntoView: true });
        }
      });
    }
    async generateWorksheet(options) {
      const settings = options || {};
      const shouldScroll = settings.scrollIntoView === true;
      const text = this.textInput.value.trim();
      const color = this.colorInput.value;
      if (!text) {
        alert('Please enter some text to trace!');
        return;
      }
      if (this.isGenerating) {
        return;
      }
      this.isGenerating = true;
      this.generateButton.disabled = true;
      try {
        await this.ensureFontReady();
        this.previewContainer.classList.add('active');
        const sentence = text.trim();
        const lineWidth = Math.max(
          this.previewContent.clientWidth || this.previewContainer.clientWidth || this.clientWidth,
          80
        );
        const measureRow = document.createElement('div');
        measureRow.className = 'ai-tracing-generator__worksheet-row-' + this.blockId;
        measureRow.style.cssText =
          'position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:' +
          lineWidth +
          'px;';
        const measureText = document.createElement('div');
        measureText.className = 'ai-tracing-generator__tracing-text-' + this.blockId;
        measureText.style.width = '100%';
        measureText.style.maxWidth = '100%';
        measureText.style.transform = 'none';
        measureText.style.position = 'relative';
        measureText.style.top = '0';
        measureRow.appendChild(measureText);
        this.previewContent.appendChild(measureRow);
        await this.waitForLayout();
        const lineRows = this.buildWrappedRepeatingRows(
          measureText,
          sentence,
          this.rowsPerPage
        );
        measureRow.remove();
        const fragment = document.createDocumentFragment();
        for (let i = 0; i < lineRows.length; i++) {
          fragment.appendChild(this.createWorksheetRow(lineRows[i], color));
        }
        this.previewContent.replaceChildren(fragment);
        await this.waitForLayout();
        this.fitRowsWithinWidth();
        this.printButton.classList.add('visible');
        if (shouldScroll) {
          setTimeout(() => {
            this.previewContainer.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }, 100);
        }
      } finally {
        await this.waitForLayout();
        this.lastObservedWidth = Math.round(this.getBoundingClientRect().width);
        this.generateButton.disabled = false;
        this.isGenerating = false;
      }
    }
    printWorksheet() {
      if (
        !this.previewContent ||
        !this.previewContainer.classList.contains('active') ||
        !this.previewContent.querySelector('.ai-tracing-generator__worksheet-row-' + this.blockId)
      ) {
        alert('Please generate a worksheet first!');
        return;
      }
      const rows = Array.from(
        this.previewContent.querySelectorAll(
          '.ai-tracing-generator__worksheet-row-' + this.blockId
        )
      );
      if (!rows.length) {
        alert('Please generate a worksheet first!');
        return;
      }
      const sampleText = rows[0].querySelector(
        '.ai-tracing-generator__tracing-text-' + this.blockId
      );
      const textStyles = sampleText ? window.getComputedStyle(sampleText) : null;
      const rowStyles = window.getComputedStyle(rows[0]);
      const fontSizePx = textStyles ? parseFloat(textStyles.fontSize) || 40 : 40;
      const textColor =
        (textStyles && textStyles.color) || this.colorInput.value || '#000000';
      const rowHeightPx = parseFloat(rowStyles.height) || fontSizePx * 2.2;
      const previewWidthPx = Math.max(
        this.previewContent.getBoundingClientRect().width,
        320
      );
      const textPadding = textStyles ? textStyles.padding : '0 12px';
      // Exact preview lines — never regenerate for print
      const lineSnapshots = rows.map((row) => {
        const textEl = row.querySelector(
          '.ai-tracing-generator__tracing-text-' + this.blockId
        );
        const inner = row.querySelector(
          '.ai-tracing-generator__tracing-text-inner-' + this.blockId
        );
        const computed = textEl ? window.getComputedStyle(textEl) : null;
        return {
          text: inner ? inner.textContent : textEl ? textEl.textContent : '',
          color:
            (textEl && textEl.style.color) ||
            (computed && computed.color) ||
            textColor,
          letterSpacing:
            (inner && inner.style.letterSpacing) ||
            '0px',
          innerTransform:
            (inner && inner.style.transform) ||
            'scaleX(1)',
          fontSize: (computed && computed.fontSize) || fontSizePx + 'px',
          padding: (computed && computed.padding) || textPadding
        };
      });
      const fontUrl = this.fontUrl;
      const blockId = this.blockId;
      const fontRatio = fontSizePx / Math.max(rowHeightPx, 1);
      const printWindow = window.open('', '_blank', 'width=900,height=1100');
      if (!printWindow) {
        alert('Please allow pop-ups to print the worksheet.');
        return;
      }
      const printStyles =
        '<style>' +
        "@font-face { font-family: 'EagerSentenceTracing'; src: url('" +
        fontUrl +
        "') format('truetype'); font-weight: normal; font-style: normal; }" +
        '@page { size: A4 portrait; margin: 8mm; }' +
        '*, *::before, *::after { box-sizing: border-box; }' +
        'html, body { margin: 0; padding: 0; background: #fff; width: 100%; height: 100%; }' +
        'body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }' +
        '.print-page { width: 194mm; height: 281mm; margin: 0 auto; display: flex; }' +
        '.print-worksheet-container { width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: stretch; padding: 0; background: #fff; }' +
        '.ai-tracing-generator__worksheet-row-' +
        blockId +
        ' { position: relative; display: block; width: 100%; flex: 1 1 0; min-height: 0; overflow: visible; box-sizing: border-box; page-break-inside: avoid; break-inside: avoid; }' +
        '.ai-tracing-generator__tracing-text-' +
        blockId +
        ' { position: absolute; left: 0; right: 0; top: 50%; transform: translateY(-50%); width: 100%; ' +
        'box-sizing: border-box; white-space: nowrap; overflow: visible; padding: 0 10mm 0 4mm; ' +
        'font-family: "EagerSentenceTracing", cursive !important; line-height: 1; font-weight: normal; z-index: 2; ' +
        'text-rendering: geometricPrecision; -webkit-font-smoothing: antialiased; ' +
        '-webkit-print-color-adjust: exact; print-color-adjust: exact; }' +
        '.ai-tracing-generator__tracing-text-inner-' +
        blockId +
        ' { display: inline-block; white-space: nowrap; transform-origin: left center; }' +
        '@media print { html, body, .print-page, .print-worksheet-container { width: 194mm; height: 281mm; margin: 0; } }' +
        '</style>';
      printWindow.document.open();
      printWindow.document.write(
        '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Tracing Worksheet</title>' +
          printStyles +
          '</head><body><div class="print-page"><div class="print-worksheet-container"></div></div></body></html>'
      );
      printWindow.document.close();
      const buildAndPrint = function () {
        const doc = printWindow.document;
        const container = doc.querySelector('.print-worksheet-container');
        if (!container) {
          return;
        }
        const fragment = doc.createDocumentFragment();
        for (let i = 0; i < lineSnapshots.length; i++) {
          const snap = lineSnapshots[i];
          const row = doc.createElement('div');
          row.className = 'ai-tracing-generator__worksheet-row-' + blockId;
          const tracingText = doc.createElement('div');
          tracingText.className = 'ai-tracing-generator__tracing-text-' + blockId;
          tracingText.style.color = snap.color;
          const inner = doc.createElement('span');
          inner.className = 'ai-tracing-generator__tracing-text-inner-' + blockId;
          inner.textContent = snap.text;
          inner.style.transform = 'none';
          inner.style.transformOrigin = 'left center';
          tracingText.appendChild(inner);
          row.appendChild(tracingText);
          fragment.appendChild(row);
        }
        container.appendChild(fragment);
        const printedRows = container.querySelectorAll(
          '.ai-tracing-generator__worksheet-row-' + blockId
        );
        printedRows.forEach(function (row) {
          const textEl = row.querySelector(
            '.ai-tracing-generator__tracing-text-' + blockId
          );
          const rowHeight = row.getBoundingClientRect().height;
          if (textEl && rowHeight > 0) {
            textEl.style.fontSize = rowHeight * fontRatio + 'px';
          }
        });
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            printedRows.forEach(function (row) {
              const textEl = row.querySelector(
                '.ai-tracing-generator__tracing-text-' + blockId
              );
              const inner = row.querySelector(
                '.ai-tracing-generator__tracing-text-inner-' + blockId
              );
              if (!textEl || !inner || !inner.textContent) return;
              inner.style.transform = 'none';
              const available = textEl.clientWidth;
              const used = inner.getBoundingClientRect().width;
              if (available > 1 && used > 1) {
                inner.style.transform = 'scaleX(' + available / used + ')';
              }
            });
            printWindow.focus();
            printWindow.print();
            setTimeout(function () {
              printWindow.close();
            }, 400);
          });
        });
      };
      const prepare = function () {
        const loadFont = printWindow.document.fonts
          ? printWindow.document.fonts.load('72px "EagerSentenceTracing"')
          : Promise.resolve();
        Promise.resolve(loadFont)
          .then(function () {
            return printWindow.document.fonts ? printWindow.document.fonts.ready : null;
          })
          .then(function () {
            setTimeout(buildAndPrint, 200);
          })
          .catch(function () {
            setTimeout(buildAndPrint, 400);
          });
      };
      setTimeout(prepare, 50);
    }
  }
  if (!customElements.get('tracing-worksheet-generator')) {
    customElements.define('tracing-worksheet-generator', TracingWorksheetGenerator);
  }
  } catch(e) { console.error(e); }
})();

})();
